'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pl_PL = require('../../date-picker/locale/pl_PL');

var _pl_PL2 = _interopRequireDefault(_pl_PL);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _pl_PL2['default'];